import axios from 'axios';
import { TipoPuntoVentaModel } from '../../pages/catalogos/tipo_punto_venta/models/TipoPuntoVentaModel';

const API_URL = process.env.REACT_APP_API;

export async function obtenerTiposPuntoVentaService() {
  try {
    const response = await axios.get(`${API_URL}tipoPuntoVenta`);
    return response.data.doc.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function obtenerTiposActivosPuntoVentaService(): Promise<{ value: string; label: string }[]> {
  try {
    const response = await axios.get(`${API_URL}tipoPuntoVenta`);
    const data = response.data.doc.data;
    const rows: TipoPuntoVentaModel[] = data.rows ?? data;
    return rows
      .filter((t) => t.activo)
      .map((t) => ({ value: t.codigo, label: t.codigo }));
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function obtenerTipoPuntoVentaPorIdService(id: number) {
  try {
    const response = await axios.get(`${API_URL}tipoPuntoVenta/${id}`);
    return response.data.doc.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function guardarTipoPuntoVentaService(tipo: TipoPuntoVentaModel) {
  try {
    const { id, nombre, codigo, activo } = tipo;
    if (id) {
      const response = await axios.put(`${API_URL}tipoPuntoVenta/${id}`, { nombre, activo });
      return response;
    } else {
      const response = await axios.post(`${API_URL}tipoPuntoVenta`, { nombre, codigo });
      return response;
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function eliminarTipoPuntoVentaService(id: number) {
  try {
    const response = await axios.delete(`${API_URL}tipoPuntoVenta/${id}`);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
